import type { RootState } from 'src/redux/store'

export const selectListOfMenuSite = (state: RootState): Meta.ListOfMenuSite =>
  state['@meta'].listOfMenuSite.data

export const selectDetailMenuSite = (state: RootState): Meta.MetaData =>
  state['@meta'].detailMenuSite.data

export const selectIsBot = (state: RootState): boolean => state['@meta'].isBot

export const selectTrackers = (state: RootState): Meta.Trackers[] =>
  state['@meta'].trackers.data

export const selectScripts = (
  state: RootState
): Meta.ShoppingCartTrackersData[] => state['@meta'].scripts.data

export const selectMenuMode = (state: RootState): string =>
  state['@meta'].detailMenuSite.mode
